module.exports = __webpack_public_path__ + "static/media/book-lover.4707aa7d.png";